import { POSITION, TYPE } from "vue-toastification"
import ToasterIconSuccess from "@/components/af/Toaster/ToasterIconSuccess.vue"
import ToasterIconError from "@/components/af/Toaster/ToasterIconError.vue"
import ToasterIconWarning from "@/components/af/Toaster/ToasterIconWarning.vue"
import ToasterIconInfo from "@/components/af/Toaster/ToasterIconInfo.vue"

const position = window.matchMedia(`(max-width: 960px)`).matches
  ? POSITION.BOTTOM_CENTER
  : POSITION.TOP_RIGHT

export const ToastOptions = {
  containerClassName: "af-toaster",
  bodyClassName: "af-toaster-body",
  closeButtonClassName: "af-toaster-close",
  timeout: 3000,
  position: position,
  shareAppContext: true,
  hideProgressBar: true,
  toastDefaults: {
    [TYPE.ERROR]: {
      icon: ToasterIconError,
    },
    [TYPE.SUCCESS]: {
      icon: ToasterIconSuccess,
    },
    [TYPE.WARNING]: {
      icon: ToasterIconWarning,
    },
    [TYPE.INFO]: {
      icon: ToasterIconInfo,
    },
  },
}
